import React from "react";
import { Space } from "antd";
import {
  AxButton,
  AxHeader,
  AxDivider,
  AxIconWrapper,
  AxBreadcrumb,
} from "@dynata/axiom3";

const sideBar = (
  <>
    <ul>
      <li className="title">Section Title</li>
      <li>Section Menu Item</li>
      <li className="selected">Section Menu Item</li>
      <li>Section Menu Item</li>
      <li>Section Menu Item</li>
    </ul>
    <AxDivider dashed />
    <ul>
      <li className="title">Section Title</li>
      <li>Section Menu Item</li>
      <li>Section Menu Item</li>
      <li>Section Menu Item</li>
      <li>Section Menu Item</li>
    </ul>
  </>
);

const toolbar = (
  <>
    <AxButton className="switch" color="blue" type="link" icononly={true}>
      <AxIconWrapper type="regular" size="20" icon={"fa-circle-question"} />
    </AxButton>
    <AxButton className="switch" color="blue" type="link" icononly={true}>
      <AxIconWrapper type="regular" size="20" icon={"fa-circle-user"} />
    </AxButton>
  </>
);

const breadcrumb = (
  <AxBreadcrumb>
    <AxBreadcrumb.Item href="">Projects</AxBreadcrumb.Item>
    <AxBreadcrumb.Item>Projects Name</AxBreadcrumb.Item>
  </AxBreadcrumb>
);

class NavHeader extends React.Component {
  render() {
    return (
      <div className="section table" id="header">
        <h3>Header</h3>
        <p>
          Renders a page header with built in common actions and design
          elements. The first header variant provides a tab like layout
          structure to render pages and/or sub-pages along with a side bar. The
          second variant provides breadcrumb navigation.
        </p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space size="large" direction="vertical">
          <pre>
            {`
<AxHeader sideBar={sideBar}>
  <AxHeader.Page pageId="p1" label="Page One"> ... </AxHeader.Page>
</AxHeader>

OR

<AxHeader breadcrumb={breadcrumb}></AxHeader>
            `}
          </pre>

          <div className="prop-header">
            <p className="props-title">Props</p>
          </div>
          <table className="props-table">
            <tbody>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Value</th>
              </tr>
              <tr>
                <td>defaultSelectedPageId</td>

                <td>Default is, first Page/sub-page item.</td>
                <td>string</td>
              </tr>
              <tr>
                <td>onPageSelected</td>

                <td>
                  Callback function that executes when a header page/sub-page
                  item is clicked, changing the current visible page.
                </td>
                <td>
                  <code>{`(Page.pageId) => void`}</code>
                </td>
              </tr>

              <tr>
                <td>assistiveToolbar</td>

                <td>
                  Renders an assistive toolbar to the right of the header.
                </td>
                <td>ReactNode</td>
              </tr>

              <tr>
                <td>sideBar</td>

                <td>Renders a sidebar for the hamburger menu.</td>
                <td>ReactNode</td>
              </tr>
              <tr>
                <td>breadcrumb</td>

                <td>
                  Renders a header with breadcrumb component instead of tab like
                  menus. If provided, children components are ignored.
                </td>
                <td>AxBreadcrumb</td>
              </tr>
              <tr>
                <td>customHeader</td>
                <td>
                  Ignores all other props and only renders the provided
                  component.
                </td>
                <td>ReactNode</td>
              </tr>
              <tr>
                <td>children</td>
                <td>
                  Ignored if `breadcrumb` or `customHeader` prop is provided.
                  For a dropdown header menu with sub-pages, create
                  AxHeader.Page or [AxHeader.Page] inside a top level
                  AxHeader.Page.
                </td>
                <td>AxHeader.Page | [AxHeader.Page]</td>
              </tr>
            </tbody>
          </table>
          <div className="prop-header">
            <p className="props-title">Props: AxHeader.Page</p>
          </div>
          <table className="props-table">
            <tbody>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Value</th>
              </tr>
              <tr>
                <td>pageId</td>
                <td>Required</td>
                <td>string</td>
              </tr>
              <tr>
                <td>label</td>
                <td>Required</td>
                <td>string</td>
              </tr>
            </tbody>
          </table>
        </Space>

        <AxDivider orientation="left" plain>
          With Pages/Sub-pages and side bar
        </AxDivider>
        <Space size="large" direction="vertical">
          <pre>
            {`
const sideBar = (
  <>
    <ul>
      <li className="title">Section Title</li>
      <li>Section Menu Item</li>
      <li className="selected">Section Menu Item</li>
      <li>Section Menu Item</li>
      <li>Section Menu Item</li>
    </ul>
    <AxDivider dashed />
    <ul>
      <li className="title">Section Title</li>
      <li>Section Menu Item</li>
      <li>Section Menu Item</li>
      <li>Section Menu Item</li>
      <li>Section Menu Item</li>
    </ul>
  </>
);

const toolbar = (
  <>
    <AxButton className="switch" color="blue" type="link" icononly={true}>
      <AxIconWrapper type="regular" size="20" icon={"fa-circle-question"} />
    </AxButton>
    <AxButton className="switch" color="blue" type="link" icononly={true}>
      <AxIconWrapper type="regular" size="20" icon={"fa-circle-user"} />
    </AxButton>
  </>
);

<AxHeader
  assistiveToolbar={toolbar}
  sideBar={sideBar}
  defaultSelectedPageId="one"
>
  <AxHeader.Page pageId="sub-pages" label="Sub Pages">
    <AxHeader.Page pageId="s1" label="Sub Item One">
      <h3>Dropdown Item One</h3>
    </AxHeader.Page>
    <AxHeader.Page pageId="s2" label="Sub Item Two">
      <h3>Dropdown Item Two</h3>
    </AxHeader.Page>
  </AxHeader.Page>

  <AxHeader.Page pageId="one" label="Item One">
    <h3>Page One</h3>
  </AxHeader.Page>
  <AxHeader.Page pageId="two" label="Item Two">
    <h3>Page Two</h3>
  </AxHeader.Page>

  <AxHeader.Page pageId="three" label="Item Three">
    <h3>Page Three</h3>
  </AxHeader.Page>

  <AxHeader.Page pageId="four" label="Item Four">
    <h3>Page Four</h3>
  </AxHeader.Page>

  <AxHeader.Page pageId="five" label="Item Five">
    <h3>Page Five</h3>
  </AxHeader.Page>
</AxHeader>

  `}
          </pre>
          <div
            style={{ background: "#F1F2F3", padding: "15px", width: "100%" }}
          >
            <AxHeader
              assistiveToolbar={toolbar}
              sideBar={sideBar}
              defaultSelectedPageId="one"
            >
              <AxHeader.Page pageId="sub-pages" label="Sub Pages">
                <AxHeader.Page pageId="s1" label="Sub Item One">
                  <h3>Dropdown Item One</h3>
                </AxHeader.Page>
                <AxHeader.Page pageId="s2" label="Sub Item Two">
                  <h3>Dropdown Item Two</h3>
                </AxHeader.Page>
              </AxHeader.Page>

              <AxHeader.Page pageId="one" label="Item One">
                <h3>Page One</h3>
              </AxHeader.Page>
              <AxHeader.Page pageId="two" label="Item Two">
                <h3>Page Two</h3>
              </AxHeader.Page>

              <AxHeader.Page pageId="three" label="Item Three">
                <h3>Page Three</h3>
              </AxHeader.Page>

              <AxHeader.Page pageId="four" label="Item Four">
                <h3>Page Four</h3>
              </AxHeader.Page>

              <AxHeader.Page pageId="five" label="Item Five">
                <h3>Page Five</h3>
              </AxHeader.Page>
            </AxHeader>
          </div>
        </Space>

        <AxDivider orientation="left" plain>
          With breadcrumb
        </AxDivider>
        <Space size="large" direction="vertical">
          <pre>
            {`
const breadcrumb = (
  <AxBreadcrumb>
    <AxBreadcrumb.Item href="">Projects</AxBreadcrumb.Item>
    <AxBreadcrumb.Item>Projects Name</AxBreadcrumb.Item>
  </AxBreadcrumb>
);
return (
  <AxHeader breadcrumb={breadcrumb}></AxHeader>
);            
            `}
          </pre>
          <div
            style={{ background: "#F1F2F3", padding: "15px", width: "100%" }}
          >
            <AxHeader breadcrumb={breadcrumb}></AxHeader>
          </div>
        </Space>
      </div>
    );
  }
}
export default NavHeader;
